import { render, staticRenderFns } from "./CandidateAspirants.vue?vue&type=template&id=4959170c&scoped=true&"
import script from "./CandidateAspirants.vue?vue&type=script&lang=js&"
export * from "./CandidateAspirants.vue?vue&type=script&lang=js&"
import style0 from "./CandidateAspirants.vue?vue&type=style&index=0&id=4959170c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4959170c",
  null
  
)

export default component.exports